import { InlineSpinner } from '../../components/common/spinner';
import { PageHeader } from '../../components/modals/settings-modal/page-header';
import { getMemberPrivacyKey, useVersionedRecord } from '../../hooks/api/useVersionedRecords';
import { resolveTheme } from '../../themes';

export const PrivacyPolicy = () => {
  const theme = resolveTheme();
  const memberPrivacyKey = getMemberPrivacyKey(theme.id);
  const { data: privacyPolicy, isLoading: isPrivacyPolicyLoading } = useVersionedRecord(memberPrivacyKey);

  return (
    <div className="p-6">
      <PageHeader header="Privacy Policy" />
      {isPrivacyPolicyLoading ? (
        <div className="flex h-full w-full items-center justify-center py-12">
          <InlineSpinner />
        </div>
      ) : (
        <div
          className="font-open-sans prose prose-h2:font-bold mt-6 space-y-2 py-4 [counter-reset:listCounter] [&_ol>li]:before:content-[counter(listCounter)_'._'] [&_ol>li]:before:[counter-increment:listCounter] [&_ul]:list-disc [&_ul]:pl-4"
          dangerouslySetInnerHTML={{
            __html: privacyPolicy?.text ?? '',
          }}
        />
      )}
    </div>
  );
};
